import { render, staticRenderFns } from "./DocumentFooter.vue?vue&type=template&id=590bbb0c&scoped=true&"
import script from "./DocumentFooter.vue?vue&type=script&lang=ts&"
export * from "./DocumentFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590bbb0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590bbb0c')) {
      api.createRecord('590bbb0c', component.options)
    } else {
      api.reload('590bbb0c', component.options)
    }
    module.hot.accept("./DocumentFooter.vue?vue&type=template&id=590bbb0c&scoped=true&", function () {
      api.rerender('590bbb0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DocumentFooter.vue"
export default component.exports